<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <div
              class="col-24 d-flex justify-content-between flex-md-row flex-column"
            >
              <div class="">
                <h1
                  class="title pt-2 mb-0"
                  v-text="$ml.get('monthlyRanking')"
                ></h1>
                <h1 class="title">
                  <span v-text="$ml.get('expertRating')" class="pb-2"></span>
                </h1>
              </div>
              <date-picker
                v-model="selectedDate"
                :format="format"
                :type="'month'"
                prefix-class="xmx"
                :placeholder="datePlaceholder"
                :lang="lang"
              ></date-picker>
            </div>

            <div class="col-24 col-md-24 py-2 d-flex flex-column"></div>
            <div class="card mb-3">
              <div class="card-body">
                <div class="d-column flex-row">
                  <div class="loading d-flex">
                    <div v-if="loading" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!itensRank.length"
                      class="p-1"
                      v-text="$ml.get('rankingDoesNotHaveEnoughDataYet')"
                    >
                      O Ranking ainda não tem dados suficientes
                    </h6>
                  </div>

                  <div
                    v-for="(item, index) in itensRank"
                    :key="index"
                    :class="
                      'h-profile d-flex pt-3 pb-3 align-items-center ' +
                      (itensRank.length == index + 1 ? 'no' : '')
                    "
                  >
                    <div
                      class="position-relative align-self-center d-flex align-items-center align-self-center"
                    >
                      <object
                        width="42"
                        height="42"
                        :data="item.avatar"
                        type="image/png"
                      >
                        <img
                          width="42"
                          height="42"
                          src="../assets/images/default.png"
                          alt="Avatar hacker"
                        />
                      </object>

                      <div v-if="item.verified" class="verify">
                        <img
                          src="../../src/assets/icons/badge-check.png"
                          width="16"
                          height="16"
                        />
                      </div>
                    </div>
                    <div
                      class="pl-3 d-flex align-items-center d-flex w-100 justify-content-between"
                    >
                      <div class="align-self-start">
                        <h3>
                          <a
                            href=""
                            class="link-block"
                            v-text="item.username"
                            @click.prevent
                          ></a>
                        </h3>
                        <p class="mt-1 text-dark d-flex justify-content-start">
                          {{ item.score }}
                          <font class="pl-1" v-text="$ml.get('points')"></font>
                        </p>
                      </div>
                      <div class="d-flex">
                        <div class="rank rank-relative">
                          <span class="p-2">{{ index + 1 }}°</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import RankingService from "../services/ranking.service";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: true,
      value: null,
      itensRank: [],
      filterDate: moment().format("YYYY-MM"),
      selectedMonth: moment().format("YYYY-MM"),
      selectedDate: moment(),
      format: "MM/YYYY",

      lang: {
        formatLocale: {
          firstDayOfWeek: "pt-BR",
        },
        monthsBeforeYear: false,
      },
    };
  },
  computed: {
    selectMonth() {
      return moment(this.selectedDate).format("MM/YYYY").split("/")[0];
    },
    selectYear() {
      return moment(this.selectedDate).format("MM/YYYY").split("/")[1];
    },
    datePlaceholder() {
      return moment(this.selectedDate).format("MM/YYYY");
    },
  },

  watch: {
    selectMonth() {
      return this.changeDados();
    },
  },
  mounted() {
    this.changeDados();
  },

  methods: {
    async changeDados() {
      const page = 1;
      const pageSize = 15;
      this.loading = true;
      this.itensRank = [];
      RankingService.getRankingMensal(
        page,
        pageSize,
        this.selectMonth,
        this.selectYear,
      ).then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data.items;
          this.totalPages = response.data.total;
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style lang="scss">
@import "../assets/sass/lib/datepicker.scss";
</style>
